import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

  urlInstagram = 'https://www.instagram.com/aborigen.styles/'
  urlFacebook = 'https://www.facebook.com/profile.php?id=100085221776750'
  whatsapp ='https://wa.me/+34641612226'
  urlTikTok = 'https://www.tiktok.com/@aborigen.styles?_r=1&_t=ZN-96xmJNYcRzK'
  goToLink(url:any){
    window.open(url, "_blank")
  }
}
